import { iconCategoryCssClass, iconSportCssClass } from '../../data/utils';
import ContentWrapper from '../../common/ContentWrapper';
import SportHeader from '../../common/SportHeader';
import EventPreview from './EventPreview';
import { useParams } from '../../router/Router';
import TournamentHeader from '../../prematch/TournamentHeader';
import EventContainer from './EventContainer';
import { useSportData } from '../sport/SportDataProvider';
import ErrorMessage from '../../common/ErrorMessage';
import { getLabel } from '../../InitData';
import StreamingProvider from '../../common/live-tracker/StreamingProvider';
import WidgetContainer from '../../common/WidgetContainer';

export default function Event() {
    const sportData = useSportData();
    const p = useParams();

    try {
        const sport = sportData.sportById[p.sportId];
        const sportIcon = iconSportCssClass(sport.id, sport.iconClass);
        const category = sport.categoryById[p.categoryId];
        const categoryIcon = iconCategoryCssClass(category.sportRef, category.categoryRef, category.categoryIcon);
        const t = category.tournamentById[p.tournamentId];
        const [pal, avv] = [p.pal, p.avv];
        const event = t.events.find(e => e.pal === pal && e.avv === avv);
    
        return (
            <StreamingProvider>
                <ContentWrapper columns="2">
                    <div className="c_30">
                        <WidgetContainer data-sticky />
                        <div className="c_30_1">
                            <SportHeader icon={sportIcon} desc={sport.descrizione} />
                            <TournamentHeader icon={categoryIcon} desc={t.descrizione} />
                            {t.events.map(e =>
                                <EventPreview key={e.uniqueId} data={e} active={e.uniqueId === event.uniqueId} />
                            )}
                        </div>
                    </div>
                    <EventContainer key={event.uniqueId} data={event} />
                </ContentWrapper>
            </StreamingProvider>
        );
    } catch (e) {
        return <ErrorMessage text={getLabel('general.error')} />
    }
}
